import { Toaster } from "@fluentui/react-components";
import { useToastMessage } from "../../components/ToastMessage/ToastMessage";
import Documents from "./Messages_Documents/Documents";
import Messages from "./Messages_Documents/Messages";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { fetchAllDocumentMessage } from "../../redux/clientPortal/clientPortalslice";

const AssystPortal = () => {
  const { showToast, toasterId } = useToastMessage();
  const { userId } = useSelector((state: RootState) => state.authUser);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 30,
  });
  const dispatch = useDispatch<AppDispatch>();
  const { message, documents } = useSelector(
    (state: RootState) => state.portal
  );
  useEffect(() => {
    if (userId) {
      dispatch(
        fetchAllDocumentMessage({
          userId,
          page: pagination.page,
          limit: pagination.limit,
        })
      );
    }
  }, [pagination.page, pagination.limit]);

  const totalFetchedMessages =
    message.received.length +
    message.received.length +
    documents.received.length +
    documents.sent.length;

  return (
    <>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "20px",
          padding: "10px",
        }}
      >
        <Messages
          notify={showToast}
          pagination={pagination}
          setPagination={setPagination}
          totalFetchedMessages={totalFetchedMessages}
        />
        <Documents
          notify={showToast}
          pagination={pagination}
          setPagination={setPagination}
          totalFetchedMessages={totalFetchedMessages}
        />
      </div>
    </>
  );
};

export default AssystPortal;
